import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css'
import { mainContext } from '../../../MainContext';
import FadeinWrap from '../../../../common/animation/FadeinWrap';


function ContainerLetter() {
  const { t } = useTranslation();

  const langCode = useContext(mainContext).langCode;


  useEffect(() => {
  }, [])


  return (
    <div className={`${styles.wrap} margin-horizontal-auto`}>
      <FadeinWrap>
        {langCode == 'ja' ?
          <img src="./img/letter/message.jpg" className={styles.img} alt="" />
        :
          <img src="./img/letter/customer.jpg" className={styles.img} alt="" />
        }
      </FadeinWrap>
    </div>
  );
}

export default ContainerLetter;